import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material'

const TableSoftware = ({ datas }) => {
  return (
    <div>
      <p
        style={{
          opacity: 1
        }}
        className="mt-5 text-primary small"
      >
        Software
      </p>

      <Table className=" mb-3 shadow-sm p-3 ">
        <TableBody
          className="text-dark "
          style={{
            position: 'sticky',
            top: '0px',
            backgroundColor: '#E0E0E0'
          }}
        >
          <TableRow className="body row fw-light font-title-table">
            <TableCell
              style={{
                fontSize: '13px',
                whiteSpace: 'nowrap',

                opacity: 1
              }}
              className="body fw-bold text-center col-1 fw-normal"
            >
              #
            </TableCell>

            <TableCell
              className="body fw-bold text-center col-3 fw-normal "
              style={{
                fontSize: '13px',
                whiteSpace: 'nowrap',

                opacity: 1
              }}
            >
              Name
            </TableCell>

            <TableCell
              className="font-link fw-bold text-center col-3 fw-normal"
              style={{
                fontSize: '13px',
                whiteSpace: 'nowrap',

                opacity: 1
              }}
            >
              Serial
            </TableCell>

            <TableCell
              className="font-link fw-bold col-3 fw-normal"
              style={{
                fontSize: '13px',
                whiteSpace: 'nowrap',
                opacity: 1
              }}
            >
              Catalog
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody style={{ background: '#FFFFFF' }}>
          {datas?.length > 0 ? (
            datas.map((d, i) => (
              <TableRow className="font-link font-small-2" key={i}>
                <TableCell
                  className="text-center"
                  style={{
                    fontSize: '14px',
                    color: '#7b818e',
                    opacity: 1
                  }}
                >
                  {i + 1}
                </TableCell>

                <TableCell
                  className="font-link font-small-2"
                  style={{
                    fontSize: '14px',
                    color: '#7b818e',
                    opacity: 1
                  }}
                >
                  {d.name}
                </TableCell>

                <TableCell
                  className="font-link font-small-2"
                  style={{
                    fontSize: '14px',
                    color: '#7b818e',
                    opacity: 1
                  }}
                >
                  {d.serial}
                </TableCell>

                <TableCell className="font-link font-small-2">
                  {d.category}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow className="mb-0">
              <TableCell
                className="text-center fw-light text-secondary small"
                colSpan={8}
              >
                -No Data-
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  )
}

export default TableSoftware
